<template>
	<div :style="{
	 	minHeight: equipment == 'pc'?'500px':'100vh'
	 }" style="user-select:text;width: 100%;">
		<el-tabs v-if="equipment == 'pc'" v-loading="loading" style="margin-top: 20px;min-height: 500px;width: 100%;"
			v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane style="overflow-x: scroll;" v-for="(item,index) in tabs" :key="index" :label="item.label"
				:name="item.name">
				<div v-for="(good,goodIndex) in item.data.data" :key="goodIndex"
					style="width:900px;background-color: #fff;border: solid 1px #d8d8d8;">
					<div
						style="display: flex;align-items: center;height: 38px;line-height: 38px;background-color: #f5f5f5;padding-left: 20px;font-size: 14px;">
						<div>{{good.created_at}}</div>
						<div style="margin-left: 20px;">{{$t('h.orderId')}}: {{good.number}}</div>
					</div>
					<div
						style="background-color: #fff;display: flex;align-items: center;padding: 10px;font-size: 14px;justify-content: space-between;">
						<div>
							<div style="display: flex;align-items: center;margin-top: 10px;"
								v-for="(products,productsIndex) in good.order_products" :key="productsIndex">
								<img :src="products.image" style="width:58px;height: 58px;">
								<div
									style="margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;height: 58px;width: 520px;">
									<div class="tit tit-hover" @click="navTo(products)">{{products.name}}</div>
									<div>x {{products.quantity}}</div>
								</div>
							</div>
						</div>
						<div
							style="margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;height: 58px;width: 120px;">
							<div style="width: fit-content;margin-left: 10px;">
								{{good.total_format}}
							</div>
							<div style="width: fit-content;margin-left: 10px;">
								{{good.status_format}}
							</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;min-width: 160px;">
							<el-button style="width: 160px;margin-left: 10px;" size="mini"
								@click="lookDetail(good)">{{$t('h.lookDetail')}}</el-button>


							<el-button
								v-if="(good.status == 'shipped' || good.status == 'completed' ) && good.order_comment.length == 0 && lcomment == 1"
								style="width: 160px;margin-top: 10px;background-color: #ff5500;color: #fff;" size="mini"
								@click="evaluation(good)">{{$t('h.evaluation')}}</el-button>
							<el-button @click="completedService(good)" v-if="good.status == 'completed'"
								style="min-width: 160px;margin-top: 10px;background-color: #635bff;color: #fff;"
								size="mini">{{$t('h.saleService')}}</el-button>

							<el-button @click="shippedConfirm(good)" v-if="good.status == 'shipped'"
								style="min-width: 160px;margin-top: 10px;background-color: #635bff;color: #fff;"
								size="mini">{{$t('h.confirmReceivedGoods')}}</el-button>
							<el-button v-if="good.status == 'unpaid'"
								style="min-width: 160px;margin-top: 10px;background-color: #635bff;color: #fff;"
								size="mini" @click="goPay(good)">{{$t('h.goPay')}}</el-button>
							<el-button v-if="good.status == 'unpaid'" class="btn"
								style="min-width: 160px;margin-top: 10px;color: #ff1943;border: solid 1px #ff1943;"
								size="mini" @click="cancelOrder(good)">{{$t('h.cancelOrder')}}</el-button>
						</div>
					</div>
				</div>
				<div v-if="item.data.data && item.data.data.length > 0" class="block"
					style="display: flex;justify-content: center;width: 100%;margin-top: 20px;">
					<el-pagination @current-change="currentChange($event,item)" layout="prev, pager, next"
						:total="item.data.total">
					</el-pagination>
				</div>
			</el-tab-pane>
		</el-tabs>


		<div style="width: 90vw;;margin: auto;overflow: hidden;" v-if="equipment == 'phone'">
			<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
				<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
					<van-loading color="#7d7d7d" type="spinner" />
				</div>
			</van-overlay>
			<van-tabs @change="handleClick" color="#635bff" :ellipsis="false" v-model="activeName">
				<van-tab v-for="(item,index) in tabs" :key="index" :title="item.label" :name="item.name">
					<div v-for="(good,goodIndex) in item.data.data" :key="goodIndex"
						style="width:calc(100% - 2px);background-color: #fff;border: solid 1px #d8d8d8;margin-top: 20px;">
						<div
							style="display: flex;align-items: center;background-color: #f5f5f5;font-size: 14px;padding: 10px;">
							<div>{{good.created_at}}</div>
							<div style="margin-left: 20px;">{{$t('h.orderId')}}: {{good.number}}</div>
						</div>
						<div
							style="background-color: #fff;display: flex;align-items: center;padding: 10px;font-size: 14px;justify-content: space-between;">
							<div>
								<div style="display: flex;align-items: center;margin-top: 10px;"
									v-for="(products,productsIndex) in good.order_products" :key="productsIndex">
									<img :src="products.image" style="width:58px;height: 58px;">
									<div
										style="margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;width: 100%;">
										<div class="tit tit-hover" @click="navTo(products)">{{products.name}}</div>
										<div style="margin-top: 4px;">
											{{good.total_format}}
										</div>
										<div style="margin-top: 4px;">
											{{good.status_format}}
										</div>
										<div style="margin-top: 4px;">x {{products.quantity}}</div>
									</div>
								</div>
							</div>
						</div>

						<div
							style="display: flex;align-items: center;justify-content: flex-end;padding-bottom: 10px;padding-right: 10px;flex-wrap: wrap;">
							<el-button style="min-width: 100px;margin-left: 10px;margin-top: 10px;" size="mini"
								@click="lookDetail(good)">{{$t('h.lookDetail')}}</el-button>

							<el-button
								v-if="(good.status == 'shipped' || good.status == 'completed' ) && good.order_comment.length == 0 && lcomment == 1"
								style="min-width: 100px;margin-top: 10px;background-color: #ff5500;color: #fff;"
								size="mini" @click="evaluation(good)">{{$t('h.evaluation')}}</el-button>

							<el-button @click="shippedConfirm(good)" v-if="good.status == 'shipped'"
								style="min-width: 100px;color: #fff;border: solid 1px #635bff;margin-top: 10px;background-color: #635bff;"
								size="mini">{{$t('h.lookDetail')}}</el-button>
							<el-button @click="completedService(good)" v-if="good.status == 'completed'"
								style="min-width: 100px;background-color: #635bff;color: #fff;margin-top: 10px;"
								size="mini">{{$t('h.saleService')}}</el-button>

							<el-button v-if="good.status == 'unpaid'" class="btn"
								style="min-width: 100px;color: #ff1943;border: solid 1px #ff1943;margin-top: 10px;"
								size="mini" @click="cancelOrder(good)">{{$t('h.cancelOrder')}}</el-button>
							<el-button v-if="good.status == 'unpaid'"
								style="min-width: 100px;background-color: #635bff;color: #fff;margin-top: 10px;"
								size="mini" @click="goPay(good)">{{$t('h.goPay')}}</el-button>
						</div>
					</div>
					<div v-if="item.data.data && item.data.data.length > 0" class="block"
						style="display: flex;justify-content: center;width: 100%;margin-top: 20px;">
						<el-pagination @current-change="currentChange($event,item)" layout="prev, pager, next"
							:total="item.data.total">
						</el-pagination>
					</div>
				</van-tab>
			</van-tabs>
			<!-- <el-tabs v-if="equipment == 'phone'" v-loading="loading" style="margin-top: 20px;min-height: 500px;"
				v-model="activeName" type="card" @tab-click="handleClick">
				<el-tab-pane v-for="(item,index) in tabs" :key="index" :label="item.label" :name="item.name">
					<div v-for="(good,goodIndex) in item.data.data" :key="goodIndex"
						style="width:calc(100% - 2px);background-color: #fff;border: solid 1px #d8d8d8;">
						<div
							style="display: flex;align-items: center;height: 38px;line-height: 38px;background-color: #f5f5f5;padding-left: 20px;font-size: 14px;">
							<div>{{good.created_at}}</div>
							<div style="margin-left: 20px;">{{$t('h.orderId')}}: {{good.number}}</div>
						</div>
						<div
							style="background-color: #fff;display: flex;align-items: center;padding: 10px;font-size: 14px;justify-content: space-between;">
							<div>
								<div style="display: flex;align-items: center;margin-top: 10px;"
									v-for="(products,productsIndex) in good.order_products" :key="productsIndex">
									<img :src="products.image" style="width:58px;height: 58px;">
									<div
										style="margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;width: 100%;">
										<div class="tit tit-hover" @click="navTo(products)">{{products.name}}</div>
										<div style="margin-top: 4px;">
											{{good.total_format}}
										</div>
										<div style="margin-top: 4px;">
											{{good.status_format}}
										</div>
										<div style="margin-top: 4px;">x {{products.quantity}}</div>
									</div>
								</div>
							</div>
						</div>

						<div
							style="display: flex;align-items: center;justify-content: flex-end;padding-bottom: 10px;padding-right: 10px;margin-top: 10px;">
							<el-button style="width: 100px;margin-left: 10px;" size="mini"
								@click="lookDetail(good)">{{$t('h.lookDetail')}}</el-button>

							<el-button @click="shippedConfirm(good)" v-if="good.status == 'shipped'"
								style="width: 100px;color: #fff;border: solid 1px #635bff;"
								size="mini">{{$t('h.lookDetail')}}</el-button>
							<el-button @click="completedService(good)" v-if="good.status == 'completed'"
								style="width: 100px;background-color: #635bff;color: #fff;"
								size="mini">{{$t('h.saleService')}}</el-button>

							<el-button v-if="good.status == 'unpaid'" class="btn"
								style="width: 100px;color: #ff1943;border: solid 1px #ff1943;" size="mini"
								@click="cancelOrder(good)">{{$t('h.cancelOrder')}}</el-button>
							<el-button v-if="good.status == 'unpaid'"
								style="width: 100px;background-color: #635bff;color: #fff;" size="mini"
								@click="goPay(good)">{{$t('h.goPay')}}</el-button>
						</div>
					</div>
					<div v-if="item.data.data && item.data.data.length > 0" class="block"
						style="display: flex;justify-content: center;width: 100%;margin-top: 20px;">
						<el-pagination @current-change="currentChange($event,item)" layout="prev, pager, next"
							:total="item.data.total">
						</el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs> -->
		</div>




		<!-- <el-tabs v-if="equipment == 'phone'" v-loading="loading" style="margin-top: 20px;" v-model="activeName" type="card"
			@tab-click="handleClick">
			<el-tab-pane style="overflow-x: scroll;" v-for="(item,index) in tabs" :key="index" :label="item.label" :name="item.name">
				<div v-for="(good,goodIndex) in item.data.data" :key="goodIndex"
					style="width: 900px;background-color: #fff;border: solid 1px #d8d8d8;">
					<div
						style="display: flex;align-items: center;height: 38px;line-height: 38px;background-color: #f5f5f5;padding-left: 20px;font-size: 14px;">
						<div>{{good.created_at}}</div>
						<div style="margin-left: 20px;">订单号: {{good.number}}</div>
					</div>
					<div
						style="background-color: #fff;display: flex;align-items: center;padding: 10px;font-size: 14px;justify-content: space-between;">
						<div>
							<div style="display: flex;align-items: center;margin-top: 10px;"
								v-for="(products,productsIndex) in good.order_products" :key="productsIndex">
								<img :src="products.image" style="width:58px;height: 58px;">
								<div
									style="margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;height: 58px;width: 520px;">
									<div class="tit tit-hover" @click="navTo(products)">{{products.name}}</div>
									<div>x {{products.quantity}}</div>
								</div>
							</div>
						</div>
						<div
							style="margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;height: 58px;width: 120px;">
							<div style="width: fit-content;margin-left: 10px;">
								{{good.total_format}}
							</div>
							<div style="width: fit-content;margin-left: 10px;">
								{{good.status_format}}
							</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: 160px;">
							<el-button style="width: 160px;margin-left: 10px;" size="mini"
								@click="lookDetail(good)">查看详情</el-button>
							<el-button v-if="good.status == 'unpaid'"
								style="width: 160px;margin-top: 10px;background-color: #635bff;color: #fff;" size="mini"
								@click="goPay(good)">去支付</el-button>
							<el-button v-if="good.status == 'unpaid'" class="btn"
								style="width: 160px;margin-top: 10px;color: #ff1943;border: solid 1px #ff1943;"
								size="mini" @click="cancelOrder(good)">取消订单</el-button>
						</div>
					</div>
				</div>
				<div v-if="item.data.data && item.data.data.length > 0" class="block"
					style="display: flex;justify-content: center;width: 100%;margin-top: 20px;">
					<el-pagination @current-change="currentChange($event,item)" layout="prev, pager, next"
						:total="item.data.total">
					</el-pagination>
				</div>
			</el-tab-pane>
		</el-tabs> -->

		<el-dialog :title="$t('h.evaluation')" :width="equipment == 'phone' ?'96%':'60%'"
			:before-close="()=>{evaluationDialogVisible = false}" :visible.sync="evaluationDialogVisible">
			<div v-loading="loadingComment">
				<div v-for="(item,index) in evaluationForm" :key="index">
					<el-form label-position="top" :model="item" :rules="evaluationRules" ref="evaluationForm"
						label-width="100px" class="demo-ruleForm">

						<el-form-item :label="$t('h.goods')">
							<div>{{item.product_name}}</div>
						</el-form-item>

						<el-form-item :label="$t('h.comment')" prop="content_text">
							<el-input show-word-limit :maxlength="350" :placeholder="$t('h.peleaseIpt')" :rows="2"
								type="textarea" v-model="item.content_text"></el-input>
						</el-form-item>
						<el-form-item v-if="content_type == 2" style="width: 42%;" :label="$t('h.img')">
							<van-uploader max-count="5" :preview-full-image="false"
							 @delete="
							 (file,fileIndex)=>{
							 	deleteImgEvaluation(file,fileIndex,item)
							 }" 
								v-model="item.fileList" multiple :after-read="(file, fileItem)=>{
									afterReadEvaluation(file, fileItem,item)
								}" />
						</el-form-item>
						<el-form-item style="width: 42%;" :label="$t('h.scoreNum')">
							<van-rate color="#ffaa00" touchable v-model="item.score" />
						</el-form-item>
					</el-form>
				</div>
				<el-button class="btn" style="width: 160px;background-color: #ff5500;color: #fff;padding: 10px;"
					size="mini" @click="upComments()">{{$t('h.evaluation')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog v-if="equipment == 'pc'" :title="$t('h.orderDetail')" :visible.sync="dialogVisible"
			:width="equipment == 'pc'?'60%':'96%'" :before-close="()=>{dialogVisible = false}">
			<div v-loading="detailLoading" style="width: 100%;min-height: 400px;overflow-x: scroll;">
				<div v-if="selectItem" :style="{
					width:equipment == 'pc'?'100%' :'1000px'
				}">
					<div style="width: 90%;margin: auto;display: flex;align-items: center;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.orderDetail')}}</div>
					</div>
					<div
						style="display: flex;align-items: center;width: 90%;justify-content: space-between;background-color: #f8f9fa;padding: 10px;color: #000;margin: auto;margin-top: 10px;">
						<div>
							<div>{{$t('h.orderId')}}</div>
							<div style="margin-top: 6px;">{{selectItem.order.number}}</div>
						</div>
						<div>
							<div>{{$t('h.created_at')}}</div>
							<div style="margin-top: 6px;">{{selectItem.order.created_at}}</div>
						</div>
						<div>
							<div>{{$t('h.status_format')}}</div>
							<div style="margin-top: 6px;">{{selectItem.order.status_format}}</div>
						</div>
						<div>
							<div>{{$t('h.total_format')}}</div>
							<div style="margin-top: 6px;">{{selectItem.order.total_format}}</div>
						</div>
						<div>
							<div>{{$t('h.payment_method_name')}}</div>
							<div style="margin-top: 6px;">{{selectItem.order.payment_method_name}}</div>
						</div>
						<div>
							<div>{{$t('h.shipping_method_name')}}</div>
							<div style="margin-top: 6px;">{{selectItem.order.shipping_method_name}}</div>
						</div>
					</div>

					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.addressInfo')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 50%;">
								<div>{{$t('h.sippingAddress')}}</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.name')}}: </div>
									<div>{{selectItem.order.shipping_customer_name}}</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.address')}}:</div>
									<div>{{selectItem.order.shipping_address_1}} {{selectItem.order.shipping_address_2}}
										{{selectItem.order.shipping_zone}} {{selectItem.order.shipping_country}}
									</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.emailCode')}}:</div>
									<div>{{selectItem.order.shipping_zipcode}}</div>
								</div>
							</div>
							<div style="width: 50%;">
								<div>{{$t('h.payOrderAddress')}}</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.name')}}:</div>
									<div>{{selectItem.order.payment_customer_name}}</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.address')}}:</div>
									<div>{{selectItem.order.payment_address_1}} {{selectItem.order.payment_address_2}}
										{{selectItem.order.payment_zone}} {{selectItem.order.payment_country}}
									</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.emailCode')}}:</div>
									<div>{{selectItem.order.payment_zipcode}}</div>
								</div>
							</div>
						</div>
					</div>
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.payGoods')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div v-for="(item,index) in selectItem.order.order_products" :key="index"
								style="display: flex;align-items: center;">
								<img :src="item.image" style="width: 90px;height: 90px;" />
								<div style="margin-left: 10px;">
									<div class="tit">{{item.name}}</div>
									<div style="display: flex;align-items: center;margin-top: 20px;">
										<div>{{item.price_format}}</div>
										<div style="margin-left: 10px;">x{{item.quantity}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="activeName =='shipped'"
						style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.sendCompany')}}</div>
					</div>

					<div v-if="activeName =='shipped'" style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.sendCompany')}}</div>
							</div>
							<div style="width: 70%;text-align: center;">
								<div style="color: #000;">{{$t('h.sendNum')}}</div>
							</div>
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.updateTime')}}</div>
							</div>
						</div>

						<div v-for="(item,index) in selectItem.order.order_shipments" :key="index"
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{item.express_company}}</div>
							</div>
							<div style="width: 70%;text-align: center;">
								<div style="color: #000;">{{item.express_number}}</div>
							</div>
							<div style="width: 15%;">
								<div style="color: #000;">{{item.created_at}}</div>
							</div>
						</div>
					</div>

					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.status_format')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.status_format')}}</div>
							</div>
							<div style="width: 70%;text-align: center;">
								<div style="color: #000;">{{$t('h.memo')}}</div>
							</div>
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.updateTime')}}</div>
							</div>
						</div>

						<div v-for="(item,index) in selectItem.order.order_histories" :key="index"
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{item.status_format}}</div>
							</div>
							<div style="width: 70%;text-align: center;">
								<div style="color: #000;">{{item.comment}}</div>
							</div>
							<div style="width: 15%;">
								<div style="color: #000;">{{item.updated_at}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>


		<el-dialog v-if="saleItem" :title="$t('h.saleService')" :visible.sync="dialogVisibleArms"
			:width="equipment == 'pc'?'60%':'90%'" :before-close="()=>{dialogVisibleArms = false}">
			<div v-loading="loading">
				<div style="width: 96%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
					<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
					<div style="margin-left: 10px;">{{$t('h.payGoods')}}</div>
				</div>
				<div style="width: 90%;margin: auto;margin-top: 10px;">
					<div style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
						<div v-for="(item,index) in saleItem.order_products" :key="index"
							style="display: flex;align-items: center;">
							<img :src="item.image" style="width: 90px;height: 90px;" />
							<div style="margin-left: 10px;">
								<div class="tit">{{item.name}}</div>
								<div style="display: flex;align-items: center;margin-top: 20px;">
									<div>{{item.price_format}}</div>
									<div style="margin-left: 10px;">x{{item.quantity}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<el-form label-position="top" :model="ruleForm" :rules="rules" style="margin-top: 20px;width: 100%;"
					ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<div style="display: flex;align-items: center;width: 100%;">
						<el-form-item style="width: 42%;" :label="$t('h.serviceType')">
							<el-select v-model="ruleForm.type" placeholder="">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="width: 42%;margin-left: 4px;" :label="$t('h.returnNum')" prop="quantity">
							<el-input v-model="ruleForm.quantity"></el-input>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item style="width: 42%;" :label="$t('h.isOpend')">
							<el-select v-model="ruleForm.opened" placeholder="">
								<el-option :label="$t('h.yes')" :value="1">
								</el-option>
								<el-option :label="$t('h.no')" :value="0">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="width: 42%;margin-left: 4px;" :label="$t('h.returnReason')">
							<el-select v-model="ruleForm.rma_reason_id" placeholder="">
								<el-option v-for="item in rma" :key="item.id" :label="item.name_form" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="">
						<el-form-item style="width: 42%;" :label="$t('h.memo')">
							<el-input type="textarea" :rows="2" v-model="ruleForm.comment"></el-input>
						</el-form-item>
						<el-form-item style="width: 42%;" label=" ">
							<van-uploader :preview-full-image="false" @delete="deleteImg" v-model="fileList" multiple
								:after-read="afterRead" />
						</el-form-item>
					</div>
					
					
					<el-form-item :style="{
						width:equipment == 'pc'?'60%':'100%'
					}" label=" ">
						<el-button class="btn-ok"
							style="background-color: #000;border: solid 1px #000;margin-top: 20px;width: 80%;"
							type="primary" @click="submit">{{$t('h.confirm')}}</el-button>
					</el-form-item>
					

				</el-form>
			</div>


			<!-- <el-upload :show-file-list="false" class="upload-demo" ref="upload" action="" :onChange="changeFile"
				:file-list="fileList" :before-upload="beforeAvatarUpload" :auto-upload="false">
				<el-button class="btn" size="mini" icon="el-icon-refresh">{{$t('h.changeHeadImg')}}</el-button>
				<div slot="tip" class="el-upload__tip">{{$t('h.uploadTit')}}</div>
			</el-upload> -->




		</el-dialog>




		<el-dialog v-if="equipment == 'phone'" :title="$t('h.orderDetail')" :visible.sync="dialogVisible"
			:width="equipment == 'pc'?'60%':'96%'" :before-close="()=>{dialogVisible = false}">
			<div v-loading="detailLoading" style="width: 100%;min-height: 400px;overflow-x: scroll;">
				<div v-if="selectItem" :style="{
					width:equipment == 'pc'?'100%' :'100%'
				}">
					<div style="width: 90%;margin: auto;display: flex;align-items: center;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.orderDetail')}}</div>
					</div>
					<div
						style="display: flex;width: 90%;background-color: #f8f9fa;padding: 10px;color: #000;margin: auto;margin-top: 10px;flex-direction: column;">
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.orderId')}}</div>
							<div style="margin-left: 10px;">{{selectItem.order.number}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.created_at')}}</div>
							<div style="margin-left: 10px;">{{selectItem.order.created_at}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.status_format')}}</div>
							<div style="margin-left: 10px;">{{selectItem.order.status_format}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.total_format')}}</div>
							<div style="margin-left: 10px;">{{selectItem.order.total_format}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.payment_method_name')}}</div>
							<div style="margin-left: 10px;">{{selectItem.order.payment_method_name}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.shipping_method_name')}}</div>
							<div style="margin-left: 10px;">{{selectItem.order.shipping_method_name}}</div>
						</div>
					</div>



					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.addressInfo')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 100%;">
								<div>{{$t('h.sippingAddress')}}</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.name')}}: </div>
									<div>{{selectItem.order.shipping_customer_name}}</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.address')}}:</div>
									<div>{{selectItem.order.shipping_address_1}} {{selectItem.order.shipping_address_2}}
										{{selectItem.order.shipping_zone}} {{selectItem.order.shipping_country}}
									</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.emailCode')}}:</div>
									<div>{{selectItem.order.shipping_zipcode}}</div>
								</div>
							</div>
						</div>
						
						
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 100%;">
								<div>{{$t('h.payOrderAddress')}}</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.name')}}:</div>
									<div>{{selectItem.order.payment_customer_name}}</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.address')}}:</div>
									<div>{{selectItem.order.payment_address_1}} {{selectItem.order.payment_address_2}}
										{{selectItem.order.payment_zone}} {{selectItem.order.payment_country}}
									</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.emailCode')}}:</div>
									<div>{{selectItem.order.payment_zipcode}}</div>
								</div>
							</div>
						</div>
					</div>

					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.payGoods')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div v-for="(item,index) in selectItem.order.order_products" :key="index"
								style="display: flex;align-items: center;">
								<img :src="item.image" style="width: 90px;height: 90px;" />
								<div style="margin-left: 10px;">
									<div class="tit">{{item.name}}</div>
									<div style="display: flex;align-items: center;margin-top: 20px;">
										<div>{{item.price_format}}</div>
										<div style="margin-left: 10px;">x{{item.quantity}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-if="activeName =='shipped'"
						style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.sendCompany')}}</div>
					</div>
					<div v-if="activeName =='shipped'" style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.sendCompany')}}</div>
							</div>
							<div style="width: 60%;text-align: center;">
								<div style="color: #000;">{{$t('h.sendNum')}}</div>
							</div>
							<div style="width: 20%;">
								<div style="color: #000;">{{$t('h.updateTime')}}</div>
							</div>
						</div>


						<div v-for="(item,index) in selectItem.order.order_shipments" :key="index"
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{item.express_company}}</div>
							</div>
							<div style="width: 60%;text-align: center;">
								<div style="color: #000;">{{item.express_number}}</div>
							</div>
							<div style="width: 25%;">
								<div style="color: #000;">{{item.created_at}}</div>
							</div>
						</div>
					</div>
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.status_format')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.status_format')}}</div>
							</div>
							<div style="width: 60%;text-align: center;">
								<div style="color: #000;">{{$t('h.memo')}}</div>
							</div>
							<div style="width: 20%;">
								<div style="color: #000;">{{$t('updateTime')}}</div>
							</div>
						</div>

						<div v-for="(item,index) in selectItem.order.order_histories" :key="index"
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{item.status_format}}</div>
							</div>
							<div style="width: 60%;text-align: center;">
								<div style="color: #000;">{{item.comment}}</div>
							</div>
							<div style="width: 25%;">
								<div style="color: #000;">{{item.updated_at}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getRmasStore,
		getaccountfiles,
		getaccountOrders,
		getaccountOrderItem,
		getaccountOrderCancel,
		getOrdersComplete,
		getl_comment_upload,
		l_commentComments
	} from '../../../../api/all.js'
	export default {
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				lcomment:0,
				content_type:0,
				loadingComment: false,
				fileEvaluationList: [],
				evaluationRules: {
					content_text: [{
						required: true,
						message: this.$t('h.peleaseIpt'),
						trigger: 'blur'
					}],
				},
				evaluationForm: [],
				evaluationDialogVisible: false,
				rma: [],
				options: [{
						label: this.$t('h.returnGoods'),
						value: "return"
					},
					{
						label: this.$t('h.exchange'),
						value: "exchange"
					},
					{
						label: this.$t('h.repair'),
						value: "repair"
					},

					{
						label: this.$t('h.reissue'),
						value: "reissue"
					},
					{
						label: this.$t('h.refund'),
						value: "refund"
					},
				],
				fileList: [],
				rules: {
					quantity: [{
						required: true,
						message: this.$t('h.returnNumError'),
						trigger: 'blur'
					}, ],
				},
				ruleForm: {
					order_product_id: "",
					quantity: 1,
					opened: 1,
					rma_reason_id: "",
					type: "return",
					comment: "",
					images: []
				},
				saleItem: null,
				dialogVisibleArms: false,
				detailLoading: false,
				selectItem: null,
				dialogVisible: false,
				loading: false,
				activeName: "first",
				tabs: [{
						name: "first",
						label: this.$t('h.allOrder'),
						page: 1,
						data: {}
					},
					{
						page: 1,
						status: 'unpaid',
						name: "second",
						label: this.$t('h.waitPay'),
						data: {}
					},
					{
						page: 1,
						status: 'paid',
						name: "third",
						label: this.$t('h.waitSend'),
						data: {}
					},
					{
						page: 1,
						status: 'shipped',
						name: "fourth",
						label: this.$t('h.waitReceiving'),
						data: {}
					},
					{
						page: 1,
						status: 'completed',
						name: "five",
						label: this.$t('h.completed'),
						data: {}
					}
				],
				// rules: {
				// 	backNum: [{
				// 		required: true,
				// 		message:  this.$t('h.returnNumError'),
				// 		trigger: 'blur'
				// 	}, ],
				// },
				saleItem: null,
				dialogVisibleArms: false,
				detailLoading: false,
				selectItem: null,
				dialogVisible: false,
				loading: false,
				// activeName: "first",
				// tabs: [{
				// 		name: "first",
				// 		label: this.$t('h.allOrder'),
				// 		page: 1,
				// 		data: {}
				// 	},
				// 	{
				// 		page: 1,
				// 		status: 'unpaid',
				// 		name: "second",
				// 		label: this.$t('h.waitPay'),
				// 		data: {}
				// 	},
				// 	{
				// 		page: 1,
				// 		status: 'paid',
				// 		name: "third",
				// 		label: this.$t('h.waitSend'),
				// 		data: {}
				// 	},
				// 	{
				// 		page: 1,
				// 		status: 'shipped',
				// 		name: "fourth",
				// 		label: this.$t('h.waitReceiving'),
				// 		data: {}
				// 	},
				// 	{
				// 		page: 1,
				// 		status: 'completed',
				// 		name: "five",
				// 		label: this.$t('h.completed'),
				// 		data: {}
				// 	}
				// ]
			}
		},
		async mounted() {
			console.log('getDatagetData', this.$route)
			if (this.$route.params.id) {
				await this.lookDetail({
					number: this.$route.params.id
				})
			}
			await this.getData()
		},
		methods: {
			async upComments() {
				this.$refs['evaluationForm'].forEach(item => {
					item.validate((valid) => {
						if (valid) {

						} else {
							return false
						}
					})
				})
				let valid = true
				let arr = []
				this.evaluationForm.forEach(item => {
					if (item.content_text == '') {
						valid = false
					}

					arr.push({
						ip: item.ip,
						score: item.score,
						content_text: item.content_text,
						zone: item.zone,
						videos: item.videos,
						imgs: item.imgs,
						order_id: item.order_id,
						order_product_id: item.order_product_id,
						product_name: item.product_name,
						product_id: item.product_id,
					})
				})
				if (valid) {
					try {
						this.loadingComment = true
						let data = await l_commentComments({
							comments: arr
						})
						this.loadingComment = false
						this.evaluationDialogVisible = false
						console.log('data', data)
						this.getData()
					} catch (e) {
						this.loadingComment = false
					}

				}

			},
			async afterReadEvaluation(file, fileItem, item) {
				this.loadingComment = true
				try {
					const formData = new FormData();
					formData.append('file', file.file)
					formData.append('type', 'rma')

					let imgUpload = await getl_comment_upload({
						formData
					})
					// file.url = imgUpload.data.data.value
					item.imgs.push({
						response: imgUpload.data,
						...imgUpload.data
					})
					console.log('this.evaluationForm.images', item)
					this.loadingComment = false
				} catch (e) {
					console.log('catche', e)
					this.loadingComment = false
					// this.loading = false
				}


				// 	console.log('file', file)
			},


			deleteImgEvaluation(file,fileIndex,item) {
				item.imgs.splice(fileIndex.index,1)
				console.log(file,fileIndex,item)
				// console.log('e', e)
				// let arr = []
				// this.fileEvaluationList.forEach(item => {
				// 	arr.push(item.url)
				// })
				
				// this.ruleForm.images = arr
			},
			evaluation(goods) {
				this.evaluationForm = []
				console.log('evaluationgoods', goods)
				goods.order_products.forEach(item => {
					this.evaluationForm.push({
						ip: goods.ip,
						score: 5,
						content_text: "",
						zone: "",
						videos: [],
						imgs: [],
						order_id: item.order_id,
						order_product_id: item.id,
						product_name: item.name,
						product_id: item.product_id,
						fileList: []
					})
				})
				console.log('this.evaluationForm', this.evaluationForm)

				this.evaluationDialogVisible = true
			},
			async submit() {
				const data = await getRmasStore(this.ruleForm)
				console.log('submitsubmitdata', data)
			},
			beforeAvatarUpload(file) {
				// 上传前校验
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
				const isLt2M = file.size / 1024 / 1024 < 2

				if (!isJPG) {

					this.$message.error(this.$t('h.imgTypeTips'))
				}
				if (!isLt2M) {
					this.$message.error(this.$t('h.imgSizeTips'))
				}
				// 校验通过后显示裁剪框
				return false
			},
			handlePictureCardPreview() {

			},
			handleRemove() {

			},
			deleteImg(e) {
				console.log('e', e)
				let arr = []
				this.fileList.forEach(item => {
					arr.push(item.url)
				})
				this.ruleForm.images = arr
			},
			async afterRead(file) {
				this.loading = true
				console.log('afterReadafterRead', this.loading)
				try {
					const formData = new FormData();
					formData.append('file', file.file)
					formData.append('type', 'rma')

					let imgUpload = await getaccountfiles({
						formData
					})
					file.url = imgUpload.data.data.value
					this.ruleForm.images.push(imgUpload.data.data.value)
					// this.ruleForm.values = imgUpload.data.data.value
					console.log('imgUploadimgUpload', imgUpload)
					console.log('this.ruleForm.images', this.ruleForm.images)
					this.loading = false
				} catch (e) {
					console.log('catche', e)
					// this.loading = false
				}


				console.log('file', file)
			},
			changeFile(file) {
				console.log('file', file)

			},
			async shippedConfirm(item) {
				try {
					this.loading = true
					await getOrdersComplete({
						id: item.number
					})
					await this.getData()
					this.loading = false
				} catch (e) {
					this.loading = false
				}

			},
			navTo(e) {
				console.log('ee', e)

				this.$router.push({
					path: '/products/' + e.url_name
				})
			},
			goPay(e) {
				this.$router.push({
					path: '/orders/' + e.number + '/pay'
				})
			},
			async cancelOrder(e) {
				console.log('e', e)
				try {
					this.loading = true
					await getaccountOrderCancel({
						orderId: e.number
					})
					await this.getData()
				} catch (e) {
					this.loading = false
				}
			},
			completedService(e) {
				console.log('e', e)
				this.saleItem = e
				this.dialogVisibleArms = true
				this.ruleForm.order_product_id = e.id
				// this.selectItem = e

			},
			async lookDetail(e) {
				console.log('e', e)
				this.dialogVisible = true
				try {
					this.detailLoading = true
					let data = await getaccountOrderItem({
						orderId: e.number
					})
					this.selectItem = data.data.data
					this.detailLoading = false
				} catch (e) {
					console.log('e', e)
					this.detailLoading = false
					this.selectItem = null
				}
			},
			async currentChange(e, item) {
				console.log('e', e)
				item.page = e
				await this.getData()
			},
			async getData(reload = false) {
				try {
					this.loading = true
					this.tabs.forEach(async item => {
						if (this.activeName == item.name) {
							let data = await getaccountOrders({
								page: !reload ? item.page : 1,
								status: item.status ? item.status : null
							})

							this.lcomment = data.data.lcomment
							this.content_type = data.data.content_type


							if (data.data.rma && data.data.rma.length > 0) {
								this.rma = data.data.rma
								console.log('datadata', data)
								console.log('this.rma', this.rma)
								this.ruleForm.rma_reason_id = data.data.rma[0].id
							}


							item.data = data.data.data
							item.current_page = data.data.current_page
							this.loading = false
						}
					})
					console.log('this.tabs', this.tabs)

					this.$forceUpdate()
				} catch (e) {
					console.log('e', e)
					this.loading = false
				}

			},
			async handleClick(e) {
				await this.getData(true)
			}
		}
	}
</script>

<style scoped>
	.tit {
		display: -webkit-box;
		/* 设置为WebKit内核的弹性盒子模型 */
		-webkit-box-orient: vertical;
		/* 垂直排列 */
		-webkit-line-clamp: 2;
		/* 限制显示两行 */
		overflow: hidden;
		/* 隐藏超出范围的内容 */
		text-overflow: ellipsis;
		max-width: 100%;
	}

	.tit-hover:hover {
		color: #55aaff;
		cursor: pointer;
	}

	.btn:hover {
		background-color: #fff;
	}

	.btn:focus {
		background-color: #fff;
	}

	.btn-ok:hover {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}

	.btn-ok:focus {
		background-color: #000;
		color: #fff;
		border: solid 1px #000;
	}
</style>